let isdev = process.env.NODE_ENV === "development";
// 联系方式
 const diffDomainWebInfo = {
	'witake.com': {
		phone: '020 8255 9582',
		record: '网易有道信息技术（北京）有限公司'
	},
	'hfwitake.youdao.com': {
		phone: '18825182825',
		email: ['gzlinwx@youdao.com', 'youdaoad@service.netease.com'],
		record: '网易有道信息技术（合肥）有限公司'
	},
	'www.neteasead.com': {
		phone: '13923220465',
		email: ['lijianxuan@corp.netease.com', 'youdaoad@service.netease.com'],
		record: '网易有道信息技术（北京）有限公司东莞分公司'
	},
	default: {
		phone: '18825182825',
		email: ['gzlinwx@youdao.com', 'youdaoad@service.netease.com'],
		record: '网易有道信息技术（合肥）有限公司'
	}
}

export default {
	INDEX_DATA_URL: "//c.youdao.com/dsp/index_data.json",
	ADVANTAGE_DATA_URL: "//c.youdao.com/dsp/advantage_data.json",
	IMG_DATA_URL:
		"//shared.ydstatic.com/ead/dynamic/dynamic-template/image/ow_adimg1",
	IMG_DATA_URL2:
		"//shared.ydstatic.com/ead/dynamic/dynamic-template/image/ow_adimg1/overseas_official",
	FORM_URL: "http://impservice.youdao.com/shutup/submit.s?from=XQ_2014_11",
	CMS_ADS: isdev ? "cmsApi" : "//c.youdao.com",
	WEB_INFO: diffDomainWebInfo[window.location.host] || diffDomainWebInfo.default
};



// WEBPACK FOOTER //
// ./src/util/constant.js